var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isSimpleLink)?_c('span',[_c('BaseLink',{attrs:{"link":_vm.link,"classes":"main-nav__menu-item-link"}})],1):_c('NavigationLinkSubmenu',{attrs:{"link":_vm.link}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }